module.exports = __webpack_public_path__ + "img/intro06.b3a6427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intro/intro06.png
// module id = 946
// module chunks = 1